import Cookies from 'js-cookie';
import MobileDetect from 'mobile-detect';

import {
  TRACKING_API_NAME__LOG_TRACKING,
  TRACKING_LOG_VERSION,
} from '../../../constants/tracking';

import {
  COOKIE_LOG_TRACKING_CLIENT_ID,
  COOKIE_LOG_TRACKING_SESSION_ID,
  COOKIE_CHOCOMEMBER_ID,
} from '../../../constants/cookie';

import baseFields from '../../../config/api/baseFields';

const { appId, version } = baseFields;

let md;
let isMobile;

/**
 * @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=0}
 */
export default function getGeneralFields() {
  if (!md) {
    md = new MobileDetect(window.navigator.userAgent);
    isMobile = !!md.mobile();
  }

  return {
    session_id: Cookies.get(COOKIE_LOG_TRACKING_SESSION_ID),
    installation_id: Cookies.get(COOKIE_LOG_TRACKING_CLIENT_ID),
    chocomember_id: Cookies.get(COOKIE_CHOCOMEMBER_ID),
    page_id: location.href,

    app_id: appId,
    app_ver_id: version,
    os: isMobile ? 'mobile_web' : 'desktop_web',
    // os_version: undefined,
    // ip: undefined,
    cookie_enable: String(navigator.cookieEnabled),

    timestamp: Date.now(),
    log_ver_id: TRACKING_LOG_VERSION,
    api: TRACKING_API_NAME__LOG_TRACKING,
  };
}
